import * as React from 'react'

import { useFormattableI18nProperty } from '@thg-commerce/enterprise-core'
import { Text } from '@thg-commerce/gravity-theme'
import { styled } from '@thg-commerce/gravity-patterns/theme'
import { ContentItem } from '../Product'

const PricePerUnitContainer = styled.div`
  ${Text('bodyText', 'alternate')}
`
export const PricePerUnit = ({
  price,
  content,
}: {
  price?: string | null
  content?: ContentItem[]
}) => {
  const i18nText = {
    pricePerUnitText: useFormattableI18nProperty(
      'widget.listpage.priceperunit.text',
    ),
  }
  if (!price) {
    return null
  }
  const ppu_quantity = content?.find(
    (contentItem) => contentItem.key === 'ppu_quantity',
  )
  const currency = price?.toString().charAt(0)
  const ppu_value =
    ppu_quantity?.value && 'stringValue' in ppu_quantity?.value
      ? parseFloat(price?.toString().slice(1)) /
        parseFloat(ppu_quantity?.value?.stringValue ?? 0)
      : 0
  const unit = content?.find((contentItem) => contentItem.key === 'ppu_unit')
  const ppu_unit =
    unit?.value &&
    'stringListValue' in unit?.value &&
    unit?.value?.stringListValue[0]
  if (!ppu_unit) return null
  return (
    <PricePerUnitContainer>
      {i18nText.pricePerUnitText([currency, ppu_value.toFixed(2), ppu_unit])}
    </PricePerUnitContainer>
  )
}
